
export function detailMainClassName(isDesktop, wide = false) {
	const width = wide ? "max-w-[1200px]" : "max-w-[900px]";
	const desktopPad = wide ? "px-4" : "";
	return `${isDesktop ? `${width} ${desktopPad}` : "w-full max-w-full px-[10px]"} mx-auto flex min-w-0 w-full max-w-full flex-col gap-5 overflow-x-hidden pt-6 md:pt-8 pb-8`;
}

export function DetailSectionHeading({ children, className = "" }) {
	return (
		<h2
			className={`font-Vazir-700 text-[17px] text-darkBlue mb-3 pr-0.5 ${className}`}
		>
			{children}
		</h2>
	);
}

export default function DetailAccentCard({
	children,
	className = "",
	bodyClassName = "p-5 md:p-6",
	ariaLabel,
}) {
	return (
		<section
			className={[
				"relative max-w-full overflow-hidden rounded-[16px] border border-darkBlue/10 bg-white",
				"shadow-[0_8px_24px_rgba(39,106,166,0.08)]",
				className,
			].join(" ")}
			aria-label={ariaLabel}
		>
			<div
				className="h-[3px] w-full bg-gradient-to-l from-cta via-[#FF8A6B] to-darkBlue"
				aria-hidden
			/>
			<div className={bodyClassName}>{children}</div>
		</section>
	);
}
